import { render, staticRenderFns } from "./AdminCustomersCard.vue?vue&type=template&id=3f4abad8&scoped=true"
import script from "./AdminCustomersCard.vue?vue&type=script&lang=js"
export * from "./AdminCustomersCard.vue?vue&type=script&lang=js"
import style0 from "./AdminCustomersCard.vue?vue&type=style&index=0&id=3f4abad8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4abad8",
  null
  
)

export default component.exports